module.exports = __webpack_public_path__ + "static/visual_5-769fe85dbcdcd93e00cbd4b24ac003fd.jpg";